export default __webpack_public_path__ + "static/media/reaction-wrong.222e97c7.svg";